import { render, staticRenderFns } from "./SelectedWhatsAppTemplate.vue?vue&type=template&id=9b247238"
import script from "./SelectedWhatsAppTemplate.vue?vue&type=script&lang=js"
export * from "./SelectedWhatsAppTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports